@for (pick of picks(); track pick.id.toString()) {
    <bs-linear-bet-builder-combo-container
        [pickId]="pick.id"
        [selectionState]="getSelectionState(pick)"
        [removeButtonStyle]="removeButtonStyle"
        [oddsDisplayFormat]="oddsDisplayFormat" />
}
